import React, { Component } from 'react'
import { withStyles, Button } from '@material-ui/core';
import Delete from '@material-ui/icons/Delete'

const styles = theme => ({
    root: {
        width: '100%',
        overflowX: 'scroll'
    }
})

class TrainingCourses extends Component {
    state = {
        programme: '',
        duration: '',
        orgainised_by: '',
        api_score:'',
       
        training_courses: []
    }

    componentDidMount(){
        //console.log(this.props)
        this.setState({
            training_courses:this.props.training_courses,
            
        })
    }

    componentDidUpdate(prevProps){
        if(this.props !== prevProps){
            this.setState({
                training_courses:this.props.training_courses,
              

            })
        }
    }

    onChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    onSubmit = () => {
        let d = {
            programme: this.state.programme,
            duration: this.state.duration,
            orgainised_by: this.state.orgainised_by,
            api_score: this.state.api_score,
            
        }

        let training_courses = this.state.training_courses;
        training_courses.push(d);
        this.setState({
            training_courses
        }, () => {
                this.props.setTrainingCourses(training_courses);
                this.setState({
                    programme: '',
                    duration: '',
                    orgainised_by: '',
                    api_score:'',
                })
        })
    }

    onDelete = (index) => {
        let training_courses = this.state.training_courses;
        training_courses.splice(index,1);
        this.props.setTrainingCourses(training_courses);
        this.setState({
            training_courses
        })
    }
    render() {
        let { classes } = this.props;
        return (
            <div className={classes.root}>
                <table width="100%" className="table">

                    <thead>
                        <tr >
                            <td >Programme</td>
                            <td >Duration</td>
                           
                            <td >Organized By</td>
                                        
                           
                            <td >API Score</td>
                                    
                                    
                            <td >Click + to Add</td>
                        </tr>
                       
                    </thead>
                    <tbody>
                        <tr>
                            <td >
                                <input
                                    className="form-control"
                                    type="text"
                                    name="programme"
                                    value={this.state.programme}
                                    onChange={this.onChange}
                                    placeholder="Programme"
                                />
                            </td>
                            <td>
                                <input
                                    className="form-control"
                                    type="text"
                                    name="duration"
                                    value={this.state.duration}
                                    onChange={this.onChange}
                                    placeholder="Duration"
                                />
                            </td>
                            <td >
                                <input
                                    className="form-control"
                                    type="text"
                                    name="orgainised_by"
                                    value={this.state.orgainised_by}
                                    onChange={this.onChange}
                                    placeholder="Organized By"
                                />
                            </td>

                            <td >
                                <input
                                    className="form-control"
                                    type="text"
                                    name="api_score"
                                    value={this.state.api_score}
                                    onChange={this.onChange}
                                    placeholder="API Score"
                                />
                            </td>

                           
                            
                           
                            <td>

                                <Button
                                    variant="outlined"
                                    onClick={this.onSubmit}
                                    type="button"
                                >
                                    +
                                </Button>

                            </td>
                        </tr>
                    </tbody>
                    <tbody>
                        {this.state.training_courses.map((el, index) =>

                            <tr key={index}>
                                <td>{index+1}. {el.programme}</td>
                                <td>{el.duration}</td>
                                <td>{el.orgainised_by}</td>
                                <td>{el.api_score}</td>
                                
                                
                                <td><Delete onClick={this.onDelete.bind(this,index)} /></td>
                            </tr>

                        )}
                         
                       
                    </tbody>

                </table>
            </div>
        )
    }
}

export default withStyles(styles)(TrainingCourses)